import {
  ADD_SCENARIO_ASYNC,
  CHANGE_SCENARIO_CONTENT,
  CHANGE_SCENARIO_LANG_VALUES,
  CHANGE_SCENARIO_PROPERTY,
  CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC,
  CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC,
  DELETE_SCENARIO_ASYNC,
  GET_AWARENESS_DETAILS_ASYNC,
  GET_SCENARIO_ASYNC,
  REPORT_TO_TEMPLATE_ASYNC,
  RESET_MANAGER,
  SAVE_SCENARIO_ASYNC,
  SET_SCENARIO_WAS_LOADER,
} from './constants'

const resetManager = () => ({ type: RESET_MANAGER })

export const getScenario = (id) => ({
  type: GET_SCENARIO_ASYNC.INITIATE,
  payload: { id },
})
export const getScenarioSuccess = (scenario, defaultLanguage) => ({
  type: GET_SCENARIO_ASYNC.SUCCESS,
  payload: { scenario, defaultLanguage },
})
export const getScenarioError = (error) => ({
  type: GET_SCENARIO_ASYNC.ERROR,
  error,
})
const getScenarioCancel = () => ({ type: GET_SCENARIO_ASYNC.CANCEL })

const addScenario = (companyId) => ({
  type: ADD_SCENARIO_ASYNC.INITIATE,
  payload: { companyId },
})
export const addScenarioSuccess = (scenario) => ({
  type: ADD_SCENARIO_ASYNC.SUCCESS,
  payload: { scenario },
})
export const addScenarioError = (error) => ({
  type: ADD_SCENARIO_ASYNC.ERROR,
  error,
})
const addScenarioCancel = () => ({ type: ADD_SCENARIO_ASYNC.CANCEL })

export const deleteScenario = () => ({ type: DELETE_SCENARIO_ASYNC.INITIATE })
export const deleteScenarioSuccess = () => ({
  type: DELETE_SCENARIO_ASYNC.SUCCESS,
})
export const deleteScenarioError = (error) => ({
  type: DELETE_SCENARIO_ASYNC.ERROR,
  error,
})

export const saveScenario = (id) => ({
  type: SAVE_SCENARIO_ASYNC.INITIATE,
  payload: { id },
})
export const saveScenarioSuccess = (data) => ({
  type: SAVE_SCENARIO_ASYNC.SUCCESS,
  payload: { data },
})
export const saveScenarioError = (error) => ({
  type: SAVE_SCENARIO_ASYNC.ERROR,
  error,
})
export const saveScenarioCancel = () => ({ type: SAVE_SCENARIO_ASYNC.CANCEL })

const getAwarenessDetails = () => ({
  type: GET_AWARENESS_DETAILS_ASYNC.INITIATE,
})
export const getAwarenessDetailsSuccess = (data) => ({
  type: GET_AWARENESS_DETAILS_ASYNC.SUCCESS,
  payload: { data },
})
export const getAwarenessDetailsError = (error) => ({
  type: GET_AWARENESS_DETAILS_ASYNC.ERROR,
  error,
})
const getAwarenessDetailsCancel = () => ({
  type: GET_AWARENESS_DETAILS_ASYNC.CANCEL,
})

export const reportToTemplate = (reportId) => ({
  type: REPORT_TO_TEMPLATE_ASYNC.INITIATE,
  payload: { reportId },
})
export const reportToTemplateSuccess = (scenario) => ({
  type: REPORT_TO_TEMPLATE_ASYNC.SUCCESS,
  payload: { scenario },
})
export const reportToTemplateError = (error) => ({
  type: REPORT_TO_TEMPLATE_ASYNC.ERROR,
  error,
})
const reportToTemplateCancel = () => ({
  type: REPORT_TO_TEMPLATE_ASYNC.CANCEL,
})

const createCampaignFromIncidents = (reportId, localeId, companyId) => ({
  type: CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.INITIATE,
  payload: { reportId, localeId, companyId },
})
export const createCampaignFromIncidentsSuccess = (id) => ({
  type: CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.SUCCESS,
  payload: { id },
})
export const createCampaignFromIncidentsError = (error) => ({
  type: CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.ERROR,
  error,
})
const createCampaignFromIncidentsCancel = () => ({
  type: CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.CANCEL,
})

const createCampaignFromScenario = (id, localeId) => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.INITIATE,
  payload: { id, localeId },
})
export const createCampaignFromScenarioSuccess = (id) => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.SUCCESS,
  payload: { id },
})
export const createCampaignFromScenarioError = (error) => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.ERROR,
  error,
})
const createCampaignFromScenarioCancel = () => ({
  type: CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.CANCEL,
})

const changeScenarioProperty = (value, propertyName) => ({
  type: CHANGE_SCENARIO_PROPERTY,
  payload: { value, propertyName },
})

const changeScenarioLangValues = (scenarioLangValues) => ({
  type: CHANGE_SCENARIO_LANG_VALUES,
  payload: { scenarioLangValues },
})

const changeScenarioContent = (content, contentIndex) => ({
  type: CHANGE_SCENARIO_CONTENT,
  payload: { content, contentIndex },
})

const setScenarioWasLoaded = (value) => ({
  type: SET_SCENARIO_WAS_LOADER,
  payload: { value },
})

export default {
  // to props
  resetManager,
  getScenario,
  getScenarioCancel,
  addScenario,
  addScenarioCancel,
  saveScenario,
  deleteScenario,
  getAwarenessDetails,
  getAwarenessDetailsCancel,
  changeScenarioProperty,
  reportToTemplate,
  reportToTemplateCancel,
  createCampaignFromIncidents,
  createCampaignFromIncidentsCancel,
  changeScenarioLangValues,
  changeScenarioContent,
  createCampaignFromScenario,
  createCampaignFromScenarioCancel,
  setScenarioWasLoaded,
}
